import { useState } from 'react';
import { BID_ADMIN_REJECT_REASONS, BID_REJECT_COMMENT_MAX_LENGTH } from '@/shared/constants/bids';
import { FilterSelect } from '@/shared/ui/FilterSelect';
import { ModalDialog } from '@/shared/ui/ModalDialog';

type Props = {
  isSaving: boolean;
  error: string;
  onClose: () => void;
  onConfirm: (rejectTypeId: string, rejectDescription: string) => void;
};

/** Reason + optional comment for cancelling a bid (legacy `CancelBidModal`). */
export const CancelBidModal = ({ isSaving, error, onClose, onConfirm }: Props) => {
  const [reason, setReason] = useState('');
  const [comment, setComment] = useState('');
  const [reasonError, setReasonError] = useState('');

  const confirm = () => {
    if (!reason) {
      setReasonError('Выберите причину отмены');
      return;
    }
    onConfirm(reason, comment.trim());
  };

  return (
    <ModalDialog title="Причина отказа" onClose={onClose} onSave={confirm} isSaving={isSaving}>
      <div className={`form-group${reasonError ? ' has-error' : ''}`}>
        <label className="control-label">Причина отказа *</label>
        <FilterSelect
          options={BID_ADMIN_REJECT_REASONS}
          value={reason}
          isClearable={false}
          width={500}
          onChange={(value) => {
            setReason(value);
            setReasonError('');
          }}
        />
        {reasonError && <span className="help-block">{reasonError}</span>}
      </div>
      <div className="form-group">
        <label className="control-label">
          Комментарий <small className="text-muted">необязательно, до {BID_REJECT_COMMENT_MAX_LENGTH} символов</small>
        </label>
        <textarea
          className="form-control"
          rows={4}
          maxLength={BID_REJECT_COMMENT_MAX_LENGTH}
          placeholder="Комментарий..."
          value={comment}
          onChange={(e) => setComment(e.target.value)}
        />
        <small className="text-muted pull-right">
          {comment.length}/{BID_REJECT_COMMENT_MAX_LENGTH}
        </small>
      </div>
      {error && <p className="text-red">{error}</p>}
    </ModalDialog>
  );
};
